import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GraphNameService {
  private static readonly FRENCH_STOP_WORDS = ['de', 'du', 'la', 'le', 'les', 'des', 'et', 'ou', 'à', 'au', 'aux', 'en', 'un', 'une'];
  private static readonly MAX_SHORT_NAME_LENGTH = 20;

  generateShortName(name: string): string {
    const words = name
      .replace(/[^\w\sÀ-ÿ]/g, ' ')
      .split(/\s+/)
      .filter(w => w.length > 0)
      .filter(w => !GraphNameService.FRENCH_STOP_WORDS.includes(w.toLowerCase()));

    const acronym = words
      .map(w => w.charAt(0).toUpperCase() + (w.length > 1 ? w.charAt(1).toLowerCase() : ''))
      .join('')
      .substring(0, GraphNameService.MAX_SHORT_NAME_LENGTH);

    return acronym || name.substring(0, GraphNameService.MAX_SHORT_NAME_LENGTH);
  }
}
